import { CSSProperties } from 'react';
import { COPILOT_LAYOUT, COPILOT_COLORS } from 'globalStyles';

const { SPACING } = COPILOT_LAYOUT;
const { grey, WPP } = COPILOT_COLORS;

export const dspQuickLinkStyles: { [key: string]: CSSProperties } = {
  dspClickable: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACING[4],
    cursor: 'pointer',
    padding: '0px 0px',
    border: 'none',
    borderRadius: 4,
    textDecoration: 'none',
    backgroundColor: grey,
    color: WPP.grey1000,
    fontSize: '12px',
    height: SPACING[24],
  },
  dspLink: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACING[4],
    cursor: 'pointer',
    padding: '1px 10px',
    borderRadius: 4,
    textDecoration: 'none',
    backgroundColor: grey,
    color: WPP.grey1000,
    fontSize: '12px',
    lineHeight: '10px',
  },
  dspExternalLink: {
    color: 'var(--wpp-grey-color-900)',
  },

  // modal Styles
  quickLinkContainer: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  quickLinkSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  quickLinkList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  accordionContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  linkButton: {
    width: '100%',
    justifyContent: 'flex-start',
    textAlign: 'left',
    cursor: 'pointer',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    lineHeight: '1.4',
    paddingRight: '30px',
    marginTop: SPACING[8],
    marginBottom: SPACING[4],
    position: 'relative',
    overflow: 'hidden',
  },
  openAllButton: {
    minWidth: 'auto',
    height: '24px',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 500,
    backgroundColor: 'transparent',
    borderRadius: 4,
    display: 'inline-flex',
    alignItems: 'center',
    gap: SPACING[4],
    cursor: 'pointer',
  },
  dspTitle: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: WPP.grey1000,
  },
  accordionContainer: {
    backgroundColor: WPP.grey100,
    color: WPP.grey1000,
    borderRadius: 8,
  },
  linkLabel: {
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '1.4',
    paddingRight: SPACING[24],
  },
};
